import AppSerializer from 'serializers/app';

class ReviewSerializer extends AppSerializer {
	constructor(store, props) {
		super(store, props);
	}

	get attrs() {
		return {}
	}

	get relationships() {
		return {
			user: { serialize: 'id'},
			booking: { serialize: 'id' },
		}
	}

}

export default ReviewSerializer;